import { Divider, Stack, Typography } from "@mui/material";
import { PropsWithChildren, ReactNode } from "react";
import { HeaderAddButton, HeaderFilterButton } from "./header-buttons";
import HeaderExportButton from "./header-export-button";
import HeaderColumnButton from "./header-column-button";

export interface HeaderActionContainerProps extends PropsWithChildren {
    title: ReactNode
}

export default function HeaderActions({
    title,
    children
}: HeaderActionContainerProps) {
    return <Stack direction={"row"} flexWrap={"wrap"} justifyContent={"space-between"} alignItems={"center"} gap={2} marginBottom={1}>
        <Typography component={"h1"} variant="h5">{title}</Typography>
        <Stack direction={"row"} flexWrap={"wrap"} justifyContent={"end"} gap={2}>
            {children}
        </Stack>
    </Stack>
}

function HeaderDivider() {
    return <Divider orientation="vertical" flexItem />
}

HeaderActions.AddButton = HeaderAddButton;
HeaderActions.Divider = HeaderDivider;
HeaderActions.FilterButton = HeaderFilterButton;
HeaderActions.ColumnButton = HeaderColumnButton;
HeaderActions.ExportButton = HeaderExportButton;